import Vue from 'vue';
import MenuComponent from '@app/modules/RF/CMS/Menu.vue';
export default Vue.extend({
    data: function () {
        return {
            company: 'HBD Consulting GmbH',
            name: 'Hans-Peter Bissegger',
            address1: 'Blegistrasse 5',
            address2: 'Lenggisrain 34',
            city1: '6430 Baar ZG',
            city2: '8645 Rapperswil-Jona SG',
            phone: this.$settings('owner.phone'),
            email: this.$settings('owner.email')
        };
    },
    components: {
        MenuComponent: MenuComponent
    }
});
